<template>
  <div class="relative h-full w-full bg-gray-100 flex flex-row sm:overflow-auto">
    <sidebar :isOpen="isOpen" />
    <div :class="isOpen ? 'ml-52' : 'ml-16' "  class="w-full duration-200 bg-gray-50">
      <navbar :handleNavbar="handleNavbar"/>
      <appmain />
    </div>
  </div>
</template>
<script>
import Sidebar from "./Sidebar/index.vue";
import Navbar from "./Navbar/index.vue";
import Appmain from "./Appmain/index.vue";
export default {
  name: "Layout",
  components: {
    Sidebar,
    Navbar,
    Appmain
  },
  data() {
    return {
      isOpen: true
    };
  },
  methods: {
    handleNavbar() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
